import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

interface KnowledgeBaseVideoDialogProps {
  open: boolean;
  videoUrl: string;
  onClose: () => void;
}

function KnowledgeBaseVideoDialog({ open, videoUrl, onClose }: KnowledgeBaseVideoDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      scroll="paper"
      PaperProps={{
        sx: {
          width: 'min(1120px, calc(100vw - 32px))',
          maxWidth: 'calc(100vw - 32px)',
          maxHeight: 'calc(100dvh - 32px)',
          m: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0, py: 1.5 }}>
        Instruction video
        <IconButton aria-label="close" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          p: 2,
          pt: 0,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxHeight: 'calc(100dvh - 104px)',
            aspectRatio: '16 / 9',
            bgcolor: 'common.black',
          }}
        >
          <video
            aria-label="Instruction video"
            src={videoUrl}
            controls
            controlsList="nodownload"
            autoPlay
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          >
            <track kind="captions" />
          </video>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default KnowledgeBaseVideoDialog;
